import { Component, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-digital-marketing",
  templateUrl: "./digital-marketing.component.html",
  styleUrls: ["./digital-marketing.component.scss"],
})

//export class DigitalMarketingComponent implements OnInit {
export class DigitalMarketingComponent {
  message: string = ""; // Property to hold the success/error message

  /*
  constructor() { }

  ngOnInit() {
  }
*/

  email: string = ""; // Property bound to the form input

  constructor(private http: HttpClient) {}

  sendEmail() {
    console.log("atleats come here");
    if (this.email) {
      const apiUrl =
        "https://2sdr7cfqdf.execute-api.us-east-1.amazonaws.com/default/enaikoHomeSub";

      this.http.post(apiUrl, { email: this.email }).subscribe(
        (response) => {
          console.log("Email sent successfully", response);
          // this.message = "Thank you your email " +this.email+" is subscribed! You will be notified at the earliest.";
          this.message =
            "Thank you your email is subscribed! You will be notified at the earliest.";
          this.email = ""; // Reset the email field
          this.clearMessageAfterDelay();
          // Handle successful response
          // Optionally, reset the form or provide user feedback
        },
        (error) => {
          console.error("Error sending email", error);
          this.message = "Failed to send email. Please try again later.";
          this.clearMessageAfterDelay();
          // Handle error response
          // Optionally, provide user feedback
        }
      );
    }
  }

  private clearMessageAfterDelay() {
    setTimeout(() => {
      this.message = "";
    }, 1800); // Clear the message after 5 seconds (5000 milliseconds)
  }
}
